import React from "react";
import Navbar from "../Components/Navbar";
import Hero from "../Components/Hero";
import Info from "../Components/Info";
import About from "../Components/About";
import BookAppointment from "../Components/BookAppointment";
import Reviews from "../Components/Reviews";
import Doctors from "../Components/Doctors";
import Footer from "../Components/Footer";
import TrustFeatures from "../Components/TrustFeatures";
import LabTestsByConcern from "../Components/LabTestsByConcern";
import ProductSlider from '../Components/ProductSlider';
import QuickOrder from '../Components/QuickOrder';
import OrderStep from '../Components/OrderStep';
import BlogSlider from "../Components/BlogSlider";
import SubHeader from "../Components/SubHeader";
import SearchSection from "../Components/SearchSection";
import One_slider from "../Components/slider/One_slider";
import Secound_slider from "../Components/slider/Secound_slider";
import Third_slider from "../Components/slider/Third_slider";
import Fourth_slider from "../Components/slider/Fourth_slider";
import Fifth_slider from "../Components/slider/Fifth_slider";
import Six_slider from "../Components/slider/Six_slider";
import Product_slider from "../Components/slider/Product_slider";
 import ExclusiveStore from "../Components/slider/Exclusive_Store";
 import Secoundcarrercomic from "../Components/slider/Secoundcarrercomic";
 import WhyCosmicCareness from "../Components/slider/WhyCosmicCareness";
 import AllProduct from "../Components/AllProduct";
 
import Personal_slider from "../Components/slider/Personal_slider";

// import Secoundcarrercomic from "../Components/slider/Secoundcarrercomic";
import TopBrand from "../Components/slider/TopBrand";
import HealthStats from "../Components/slider/HealthStats";




function Home() {
  return (
    <div className="home-section">

      {/* <Hero /> */}
      <SubHeader />
    <SearchSection /> 
    <One_slider />    {/* <Info /> */}
      <Secound_slider />
      <Third_slider />
      <Fourth_slider/>
      <Fifth_slider/>
        <Six_slider/>
        <Product_slider />
            <ExclusiveStore />
               <Secoundcarrercomic />
                <WhyCosmicCareness />
                <Personal_slider/>
          
<TopBrand />
<HealthStats/>
      <ProductSlider />
      {/* <LabTestsByConcern /> */}
      {/* <QuickOrder /> */}
      {/* <TrustFeatures/> */}
      {/* <Reviews /> */}
      {/* <OrderStep /> */}
     {/* <BlogSlider  />  */}
     

    </div>
  );
}

export default Home;
